;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export type ApiResponse<T = unknown> = {
  success?: boolean;
  message?: string;
  error?: string;
  type?: string;
  status?: number;
  errors?: Record<string, string[]>;
  data?: T;
  pagination?: {
    total: number;
    current_page: number;
    per_page: number;
    last_page: number;
    next_page_url?: string | null;
  };
} & (
  | { success: true; data: T }
  | { success: false; error?: string; message?: string; errors?: Record<string, string[]> }
);

/**
 * HTTP/API failures from app `fetchAPI` helpers only. Do not throw elsewhere —
 * use `Error` for app logic or `AuthError` for session/token validation.
 */
export class ApiError extends Error {
  status?: number;
  error?: string;
  errors?: Record<string, string[]>;

  constructor({
    message,
    status,
    error,
    errors,
  }: { message: string; status?: number; error?: string; errors?: Record<string, string[]> }) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.error = error;
    this.errors = errors;
  }
}

/** Cookie/JWT session validation (withAuth, logout). Not an HTTP API response. */
export class AuthError extends Error {
  readonly status = 401;
  readonly code?: string;

  constructor({ message, code }: { message: string; code?: string }) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}
